import { render, staticRenderFns } from "./TabDicionario.vue?vue&type=template&id=f9afa162&scoped=true"
import script from "./TabDicionario.vue?vue&type=script&lang=js"
export * from "./TabDicionario.vue?vue&type=script&lang=js"
import style0 from "./TabDicionario.vue?vue&type=style&index=0&id=f9afa162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9afa162",
  null
  
)

export default component.exports